import axios from "axios";

export const client = axios.create({
  baseURL: `${process.env.HOST}/api/partner`
});

export function getAccessToken() {
  return localStorage.getItem("supplierAccessToken");
}

client.interceptors.request.use(config => {
  const token = getAccessToken();

  if (!token) return config;

  return {
    ...config,
    headers: {
      ...config.headers,
      Authorization: `Bearer ${token}`
    }
  };
});

/**
 * @param {File} file
 * @param {string} feature
 *
 * @return {string}
 */
export async function uploadFile(file, feature) {
  // Create a new FormData instance
  const formData = new FormData();

  // Append the file to the FormData
  formData.append("file", file);
  formData.append("feature", feature);

  // Send the request
  const response = await client.post(
    '/upload-file',
    formData,
    { headers: { 'Content-Type': 'multipart/form-data'} }
  );

  // Extract the key from the response
  const { key } = response.data.result;

  return key;
}